import { NavigationPageList } from 'ui/components';
import { useNavigationContext } from 'application/contexts/NavigationContext';
import { PageContext } from 'application/contexts/PageContext';
import { useContext } from 'react';

export const NavigationPageListFeature: React.FC<Content.NavigationPageList> = ({ content }) => {
    const { thumbnail, resume, aZ } = content?.properties ?? {};

    const navContext = useNavigationContext();
    const pageContext = useContext(PageContext);

    const navigationItems = navContext?.getNavigation({ includeHidden: true, includeRootItem: true });
    const pageUrl = pageContext.url;
    const navItems = [];

    function findMatch(item: Navigation.NavigationItem) {
    if (item?.url === pageUrl) {
        
        item.descendants?.forEach((descendant) => {
            if (!descendant.hidden && descendant.isArticlePage) {
                navItems.push(descendant);
            }
        });
        return true;
    }

    if (item.descendants) {
        return item.descendants.some((descendant) => findMatch(descendant));
    }

    return false;
}


    navigationItems?.some((navigationItem) => {
        return findMatch(navigationItem);
    });

    return (
        <NavigationPageList
            showThumbnails={thumbnail}
            showResume={resume}
            showAZBar={aZ}
            linkboxItems={navItems.map((item) => ({
                name: item.name,
                url: item.url,
                thumbnail: item.thumbnail,
                resume: item.resume,
            }))}
        />
    );
};
